import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { de } from 'ngx-bootstrap';
import { Subscription } from 'rxjs';
import { AppointmentsService } from '../../../appointments/appointments.service';
import { AvailablestepsService } from '../../services/availablesteps.service';
import { UserInfoService } from '../../services/security.service';
import { SharedService } from '../../services/shared.service';
import { VariablePopupService } from '../../services/variable-popup.service';

@Component({
  selector: 'app-message-variables-popup',
  templateUrl: './message-variables-popup.component.html',
  styleUrls: ['./message-variables-popup.component.scss']
})

export class MessageVariablesPopupComponent implements OnInit, OnDestroy {
  @Output() updateIsOpenPopup: EventEmitter<boolean> = new EventEmitter();
  @Output() isCancelOpenPopup: EventEmitter<boolean> = new EventEmitter();
  @Input() notificationType;
  private variablePopupPayload$: Subscription;
  public variableCategories: any = [];
  public isOpenPopup: boolean;

  public allowedVariblesFor: string;
  public selectedVariableCategoryCode: string = '';
  public communicationTypeOpened: string = "";

  public listOfUsedVariableObj: Array<any>;
  public selectedVaribles: any = [];

  public showExtVariablePopup: boolean = false;
  public extVariablePopupOrgUrl: string = "";
  public extVariablePopupUrl: string = "";
  public clientCode: any;
  public userInfo: any;
  public enabledPermissions: any;

  constructor(
    private availableSteps: AvailablestepsService,
    private variablePopupService: VariablePopupService,
    private appointmentsService: AppointmentsService,
    private sharedService: SharedService,
    private userInfoService: UserInfoService
  ) {
    this.clientCode = this.sharedService.getCookie("clientCode");
    this.userInfo = this.userInfoService._info;
    this.enabledPermissions = JSON.parse(JSON.stringify(this.userInfoService.userPermissions));
  }

  ngOnInit() {
    // if (this.enabledPermissions.isJRSalesforceEnabled && this.userInfo.AccountLoginType == 'salesforce' && this.enabledPermissions.isNewVariablePopupEnabled) {
    if (this.enabledPermissions.isNewVariablePopupEnabled) {
      this.variablePopupEventListenerInit();
      this.showExtVariablePopup = true;
      let allowedVariableCategories: Array<string> = ["lead", "contact", "appointment","vacancy","recruiter"];
      this.extVariablePopupOrgUrl = `${this.appointmentsService.config.coreUrl}/variablePopup?multiple=true&fetchDspName=true&allowedDuplicate=true&entityFilter=${allowedVariableCategories.join()}&clientcode=${this.clientCode}&usageFeature=schedule`;
    }
    this.variablePopupPayload$ = this.variablePopupService.variablePopupPayload$.subscribe((payload) => {
      if (payload.isOpenPopup) {
        if (this.showExtVariablePopup) {
          // this.ngxService.start('variablePopupMain');
          this.extVariablePopupUrl = this.extVariablePopupOrgUrl;

          // if (payload.listOfUsedVariableObj && payload.listOfUsedVariableObj.length > 0) {
          //   let temp: any = {};
          //   let entityName: any = {};
          //   let fieldName: any = {};
          //   let oldVarsObj: any = {};

          //   payload.listOfUsedVariableObj.map((itemObj: any) => {
          //     if (itemObj.formula.indexOf(".") > 0) {
          //       entityName = `${itemObj.formula.replace(/\%/g, '').split('.')[0]}`;
          //       fieldName = `${itemObj.formula.replace(/\%/g, '').split('.')[1]}`;

          //       if (!temp[entityName]) {
          //         temp[entityName] = [];
          //       }
          //       temp[entityName].push(fieldName);
          //     } else {
          //       if (Object.keys(oldVarsObj).length <= 0) {
          //         this.variableCategories = JSON.parse(JSON.stringify(this.availableSteps.messageVariablesCategory));

          //         this.variableCategories.forEach((category: any) => {
          //           if (category.variables.length > 0) {
          //             category.variables.map((subObj: any) => {
          //               oldVarsObj[subObj.formula] = {
          //                 "entityName": `${category.categoryCode}`,
          //                 "fieldName": `${subObj.formula.replace(/\%/g, '')}`
          //               }
          //             });
          //           }
          //         });
          //       }

          //       if(oldVarsObj[itemObj.formula]){
          //         if (!temp[oldVarsObj[itemObj.formula].entityName]) {
          //           temp[oldVarsObj[itemObj.formula].entityName] = [];
          //         }
          //         temp[oldVarsObj[itemObj.formula].entityName].push(oldVarsObj[itemObj.formula].fieldName);
          //       }
          //     }
          //   });
          //   this.extVariablePopupUrl = `${this.extVariablePopupUrl}&selectedVariables=${JSON.stringify(temp)}`;
          // }

          if(payload.listOfUsedVariableObj && payload.listOfUsedVariableObj.length > 0){
            let selectedVariables: { [key: string]: string[] } = {};
            let oldVarsObj: { [key: string]: { entityName: string, fieldName: string } } = {};
            let variableTrackKeys: { [key: string]: number[] } = {};
  
            payload.listOfUsedVariableObj.map((itemObj:any) => {
              if(itemObj.formula.indexOf(".") > 0){
  
                const [entityName, fieldName] = itemObj.formula.replace(/\%/g, '').split('.');
                
                selectedVariables[entityName] = selectedVariables[entityName] || [];
                selectedVariables[entityName].push(fieldName);
  
                if(itemObj.key){
                  variableTrackKeys[`${entityName}.${fieldName}`] = variableTrackKeys[`${entityName}.${fieldName}`] || [];
                  variableTrackKeys[`${entityName}.${fieldName}`].push(itemObj.key);
                }
  
              }
              else{
                if(Object.keys(oldVarsObj).length <= 0){
                  this.variableCategories = JSON.parse(JSON.stringify(this.availableSteps.messageVariablesCategory));
                  
                  this.variableCategories.forEach((category:any) => {
                    if(category.variables.length > 0){
                      category.variables.forEach((subObj:any) => {
                        oldVarsObj[subObj.formula] = {
                          "entityName" : `${category.categoryCode}`,
                          "fieldName" : `${subObj.formula.replace(/\%/g,'')}`
                        }
                      });
                    }
                  });
                }
  
                if(oldVarsObj[itemObj.formula]){
  
                  const { entityName, fieldName } = oldVarsObj[itemObj.formula];
  
                  selectedVariables[entityName] = selectedVariables[entityName] || [];
                  selectedVariables[entityName].push(fieldName);
                  if(itemObj.key){
                    variableTrackKeys[`${entityName}.${fieldName}`] = variableTrackKeys[`${entityName}.${fieldName}`] || [];
                    variableTrackKeys[`${entityName}.${fieldName}`].push(itemObj.key);
                  }
  
                }
              }
            });
            this.extVariablePopupUrl += `&selectedVariables=${JSON.stringify(selectedVariables)}`;
            if(variableTrackKeys && Object.keys(variableTrackKeys).length > 0){
              this.extVariablePopupUrl += `&variableTrackKeys=${JSON.stringify(variableTrackKeys)}`
            }
          }

          let variablesToRemove:any = {
            "appointment" : ['slink']
          };
          if (this.notificationType == 1 || this.notificationType == 5) {
            variablesToRemove["appointment"] = ["ical","gcal","rclink"];
          }
          if(payload.communicationType === "smsMsg" || payload.communicationType === "followUpMsg"){
            variablesToRemove["recruiter"] = ["signature"];
          }
          variablesToRemove["appointment"].push("sourcename");
          this.extVariablePopupUrl = `${this.extVariablePopupUrl}&removeVariables=${JSON.stringify(variablesToRemove)}`;

        } else {
          this.getFilteredVariableList();
          this.listOfUsedVariableObj = payload.listOfUsedVariableObj;
          this.allowedVariblesFor = payload.allowedVariblesFor;
          this.communicationTypeOpened = payload.communicationType;
          this.filterVariablecategory(this.allowedVariblesFor);
          this.showVariableForSelectedCategory(this.variableCategories[0]);
        }
        this.isOpenPopup = payload.isOpenPopup;
      }
    });
  }

  getFilteredVariableList() {
    this.variableCategories = JSON.parse(JSON.stringify(this.availableSteps.messageVariablesCategory));
    if (this.notificationType) {
      this.variableCategories[1].variables.map(variables => {
        if (this.notificationType == 1 || this.notificationType == 5) {
          if (variables.formula == '%ical%' || variables.formula == '%gcal%' || variables.formula == '%rclink%') {
            variables.isEnable = false;
          }
        } else {
          if (variables.formula == '%slink%') {
            variables.isEnable = false;
          }
        }
      });
    }
  }

  filterVariablecategory(allowedVariblesFor: string) {
    this.variableCategories = this.variableCategories.filter(category => {
      if (!category.allowedflow || (category.allowedflow && category.allowedflow.length > 0 && category.allowedflow.includes(allowedVariblesFor))) {
        if (this.communicationTypeOpened && category.variables.length > 0) {
          category.variables = category.variables.filter((subObj: any) => {
            if (!subObj.communicationTypeAllowed || subObj.communicationTypeAllowed.includes(this.communicationTypeOpened)) {
              return subObj;
            }
          });
        }

        return this;
      }
    });
  }

  showVariableForSelectedCategory(category: any) {
    this.selectedVariableCategoryCode = category.categoryCode;
    this.selectedVaribles = [...category.variables];
  }

  selectFormulaOfVariable(variableObj: any) {
    if (!this.listOfUsedVariableObj.includes(this.listOfUsedVariableObj.find(variable => variable.formula === variableObj.formula))) {
      this.listOfUsedVariableObj.push(variableObj);
    } else {
      this.listOfUsedVariableObj.splice(this.listOfUsedVariableObj.indexOf(this.listOfUsedVariableObj.find(variable => variable.formula === variableObj.formula)), 1);
    }
  }

  closeVariablePopup() {
    this.isOpenPopup = false;
    this.listOfUsedVariableObj = [];
    this.variablePopupService.variablePopupPayload = {};
    this.variablePopupService.changeInVariablePopupPayload();
    this.isCancelOpenPopup.emit(this.isOpenPopup);
  }

  insertFormula() {
    this.isOpenPopup = false;
    this.variablePopupService.listOfUsedVariableObj = JSON.parse(JSON.stringify(this.listOfUsedVariableObj));
    this.listOfUsedVariableObj = [];
    this.variablePopupService.variablePopupPayload = {};
    this.variablePopupService.changeInVariablePopupPayload();
    this.updateIsOpenPopup.emit(this.isOpenPopup);
  }

  insertActiveClass(variableObj): boolean {
    if (this.listOfUsedVariableObj && this.listOfUsedVariableObj.length > 0)
      return this.listOfUsedVariableObj.includes(this.listOfUsedVariableObj.find(variable => variable.formula === variableObj.formula))
    else
      return false;
  }

  ngOnDestroy(): void {
    this.variablePopupPayload$.unsubscribe();
  }

  variablePopupEventListenerInit() {
    // Detect data from variable popup
    let self = this;
    // get user info
    if (window.addEventListener) {
      window.addEventListener("message", onMessage, false);
    }
    function onMessage(event) {
      // Check sender origin to be trusted
      if (event.origin === self.appointmentsService.config.coreUrl) {
        let data = event.data;
        if (data.message == 'save') {
          if (data.selectedVariables) {
            self.isOpenPopup = false;
            self.variablePopupService.listOfUsedVariableObj = JSON.parse(data.selectedVariables);
            self.updateIsOpenPopup.emit(self.isOpenPopup);
            self.closeVariablePopup();
          }
        }
        else if (data.message == 'variableWindowLoader') {
          if (!data.isLoaderEnable) {
            // self.ngxService.stop('variablePopupMain');
          }
        }
        else if (data.message == 'cancel') {
          self.closeVariablePopup();
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/message-variables-popup/message-variables-popup.component.ts